<template>
  <div>
    <v-card flat>
      <v-card-text>
        <div class="flex my-4 mb-4">
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">Full Name:</p>
          </div>
          <div class="w-1/3 h-12">
            <p class="font-weight-medium">
              {{ values?.person?.firstname }}
              {{ values?.person?.middlename }}
              {{ values?.person?.lastname }}
            </p>
          </div>
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">Gender:</p>
          </div>
          <div class="w-1/3 h-12">
            <p class="font-weight-medium">
              {{ values.person ? values.person.gender : values.gender }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">Birth Date:</p>
          </div>
          <div class="w-1/3 h-12">
            <p class="font-weight-medium">
              {{
                values.person
                    ? values.person.birthdate
                    : values.birthdate | moment("DD MMMM, YYYY")
              }}
            </p>
          </div>
          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">Tin Number:</p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{ values.person ? values.person.tin : values.tin }}
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <v-tabs v-model="activeTab">
      <v-tab>Contacts</v-tab>
      <v-tab-item>
        <div v-if="values?.person?.contacts && values.person.contacts.length !== 0">
          <v-card
              v-for="n in values.person
              ? values.person.contacts
              : values.contacts"
              :key="n.contactguid"
              flat
          >
            <v-card-text>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">Mobile Phone:</p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{ n.mobilephone }}
                  </div>
                </div>
              </div>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">Email:</p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{ n.email ? n.email : "-" }}
                  </div>
                </div>
              </div>

              <v-divider></v-divider>
            </v-card-text>
          </v-card>
        </div>
        <div v-else>
          <v-card flat>
            <v-card-title> No contacts to display!</v-card-title>
            <v-divider></v-divider>
          </v-card>
        </div>
      </v-tab-item>
      <v-tab>Job History</v-tab>
      <v-tab-item>
        <div
            v-if="values?.person?.employee_job_histories && values.person.employee_job_histories.length !== 0"
        >
          <v-card
              v-for="n in values.person
              ? values.person.employee_job_histories
              : values.employee_job_histories"
              :key="n.employeejobhistoryguid"
              flat
          >
            <v-card-text>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">Job Title:</p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{ n.jobtitlename ? n.jobtitlename : "-" }}
                  </div>
                </div>
              </div>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">Joined Date:</p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{
                      n.joineddate
                          ? n.joineddate
                          : n.joineddate | moment("DD MMMM, YYYY")
                    }}
                  </div>
                </div>
              </div>

              <v-divider></v-divider>
            </v-card-text>
          </v-card>
        </div>
        <div v-else>
          <v-card flat>
            <v-card-title> No Job histories to display!</v-card-title>
            <v-divider></v-divider>
          </v-card>
        </div>
      </v-tab-item>
      <v-tab>Course</v-tab>
      <v-tab-item>
        <div v-if="values?.trainee_course">
          <v-card flat>
            <v-card-text>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">Course Name (Cat1):</p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{ values?.trainee_course?.course?.courseName }}
                  </div>
                </div>
                <div>
                  <v-btn
                      v-if="values?.trainee_course?.courseStatus === 'null'"
                      class="teal white--text"
                      color="primary"
                      dark
                      depressed
                      small
                      @click="gotToCourseCompletion(values?.trainee_course)"
                  >
                    <span>Complete Course</span>
                  </v-btn>
                  <v-btn
                      v-if="values?.trainee_course?.courseStatus === 'pass'"
                      class="teal white--text"
                      color="primary"
                      dark
                      depressed
                      small
                      @click="generateCerteficate(values?.trainee_course)"
                  >
                    <span>View Certificate</span>
                  </v-btn>
                  <v-btn
                      v-if="values?.trainee_course?.courseStatus === 'pass'"
                      class="white--text ml-2"
                      color="cyan"
                      dark
                      depressed
                      small
                      @click="sendCertificateEmail(values?.trainee_course)"
                  >
                    <span>Send Certificate</span>
                  </v-btn>
                  <v-btn
                      v-if="values?.trainee_course?.courseStatus === 'pending'"
                      class="teal white--text"
                      color="primary"
                      dark
                      depressed
                      small
                      disabled
                  >
                    <span>Pending Approval</span>
                  </v-btn>
                  <v-btn
                      v-if="values?.trainee_course?.courseStatus === 'fail'"
                      class="teal white--text"
                      color="primary"
                      dark
                      depressed
                      small
                      @click="viewCourseDetail(values?.trainee_course)"
                  >
                    <span>View Course</span>
                  </v-btn>
                  <!--                                    <v-btn-->
                  <!--                                      v-if="values.trainee_course.traineeStatusId !== 'null'"-->
                  <!--                                      depressed-->
                  <!--                                      class="white&#45;&#45;text ml-2"-->
                  <!--                                      dark-->
                  <!--                                      small-->
                  <!--                                      color="cyan"-->
                  <!--                                      @click="editCourseDetail(values.trainee_course)"-->
                  <!--                                    >-->
                  <!--                                      <span>Edit</span>-->
                  <!--                                    </v-btn>-->
                </div>
              </div>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">
                    Continuing Education Unit:
                  </p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{ values?.trainee_course?.course?.continualEducationUnit }}
                  </div>
                </div>
              </div>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">
                    Certificate Reason:
                  </p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{
                      values?.trainee_course?.certificate_reason?.name
                      ?? "Not Certified Yet"
                    }}
                  </div>
                </div>
              </div>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">
                    Score:
                  </p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{
                      values?.trainee_course?.score
                      ?? "Not Certified Yet"
                    }}
                  </div>
                </div>
              </div>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">
                    Course Completion Date:
                  </p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{
                      values?.trainee_course?.courseCompletionDate
                      ?? "Not Certified Yet"
                    }}
                  </div>
                </div>
              </div>
            </v-card-text>
            <v-divider></v-divider>
          </v-card>
        </div>
        <div v-else-if="values?.trainee_cat2_course">
          <v-card flat>
            <v-card-text>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">Course Name (Cat2):</p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{ values?.trainee_cat2_course?.program?.courseTitleCat2 }}
                  </div>
                </div>
                <div>
                  <v-btn
                      v-if="values?.trainee_cat2_course?.courseStatus === 'null'"
                      class="teal white--text"
                      color="primary"
                      dark
                      depressed
                      small
                      @click="gotToCourseCompletion(values?.trainee_cat2_course)"
                  >
                    <span>Complete Course</span>
                  </v-btn>
                  <v-btn
                      v-if="values?.trainee_cat2_course?.courseStatus === 'pass'"
                      class="teal white--text"
                      color="primary"
                      dark
                      depressed
                      small
                      @click="generateCerteficate(values?.trainee_cat2_course)"
                  >
                    <span>View Certificate</span>
                  </v-btn>
                  <v-btn
                      v-if="values?.trainee_cat2_course?.courseStatus === 'pass'"
                      class="white--text ml-2"
                      color="cyan"
                      dark
                      depressed
                      small
                      @click="sendCertificateEmail(values?.trainee_cat2_course)"
                  >
                    <span>Send Certificate</span>
                  </v-btn>
                  <v-btn
                      v-if="values?.trainee_cat2_course?.courseStatus === 'pending'"
                      class="teal white--text"
                      color="primary"
                      dark
                      depressed
                      small
                      disabled
                  >
                    <span>Pending Approval</span>
                  </v-btn>
                  <v-btn
                      v-if="values?.trainee_cat2_course?.courseStatus === 'fail'"
                      class="teal white--text"
                      color="primary"
                      dark
                      depressed
                      small
                      @click="viewCourseDetail(values?.trainee_cat2_course)"
                  >
                    <span>View Course</span>
                  </v-btn>
                  <!--                  <v-btn-->
                  <!--                      v-if="values.trainee_cat2_course.courseStatus !== 'null'"-->
                  <!--                      class="white&#45;&#45;text ml-2"-->
                  <!--                      color="cyan"-->
                  <!--                      dark-->
                  <!--                      depressed-->
                  <!--                      small-->
                  <!--                      @click="editCourseDetail(values.trainee_cat2_course)"-->
                  <!--                  >-->
                  <!--                    <span>Edit</span>-->
                  <!--                  </v-btn>-->
                </div>
              </div>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">
                    Continuing Education Unit:
                  </p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{ values?.trainee_cat2_course?.program?.ceu }}
                  </div>
                </div>
              </div>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">
                    Certificate Reason:
                  </p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{
                      values?.trainee_cat2_course?.certificate_reason?.name
                      ?? "Not Certified Yet"
                    }}
                  </div>
                </div>
              </div>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">
                    Score:
                  </p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{
                      values?.trainee_cat2_course?.score
                      ?? "Not Certified Yet"
                    }}
                  </div>
                </div>
              </div>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">
                    Course Completion Date:
                  </p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{
                      values?.trainee_cat2_course?.courseCompletionDate
                      ?? "Not Certified Yet"
                    }}
                  </div>
                </div>
              </div>
            </v-card-text>
            <v-divider></v-divider>
          </v-card>
        </div>
        <div v-else>
          <v-card flat>
            <v-card-title> No courses to display!</v-card-title>
            <v-divider></v-divider>
          </v-card>
        </div>
      </v-tab-item>
    </v-tabs>
    <template>
      <v-dialog v-model="courseCompletionDialog" width="60%">
        <v-card>
          <v-card-title
              class="headline font-weight-regular blue-grey white--text"
              primary-title
          >{{ title }}
          </v-card-title
          >
          <v-divider></v-divider>
          <HrdTraineeCourseComplete
              v-if="courseCompletionDialog"
              :traineeStatus="traineeStatus.data"
              :traineeUpdateCourseDetail="traineeUpdateCourseDetail"
              :userInfo="trainee"
              traineeType="old"
              @close="refreshTrainee"
          ></HrdTraineeCourseComplete>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog v-model="viewCourseDialog" width="60%">
        <v-card>
          <v-card-title
              class="headline font-weight-regular blue-grey white--text"
              primary-title
          >{{ title }}
          </v-card-title
          >
          <v-divider></v-divider>
          <HrdTraineeViewCourse
              v-if="viewCourseDialog"
              :traineeStatus="traineeStatus.data"
              :traineeUpdateCourseDetail="traineeUpdateCourseDetail"
              :userInfo="trainee"
              traineeType="old"
              @close="viewCourseDialog = false"
          ></HrdTraineeViewCourse>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog v-model="editCourseDialog" width="60%">
        <v-card>
          <v-card-title
              class="headline font-weight-regular blue-grey white--text"
              primary-title
          >Edit Certificate
          </v-card-title
          >
          <v-divider></v-divider>
          <EditCertificate
              v-if="editCourseDialog"
              :traineeStatus="traineeStatus.data"
              :traineeUpdateCourseDetail="traineeUpdateCourseDetail"
              :userInfo="trainee"
              traineeType="old"
              @close="editCourseDialog = false"
          ></EditCertificate>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import HrdTraineeCourseComplete from "../hrd-trainee-course-complete.vue";
import HrdTraineeViewCourse from "../new-trainee/hrd-trainee-view-course.vue";
import {generateCertificate1, resolveCertificateEmail} from "../generate-certiificate";
import {generateCertificate2} from "../generate-certificate-non-course";
import {TraineeService} from "../trainees.service";
import EditCertificate from "../edit-certificate.vue";
import {settings} from "@/Settings";
import {isCertificateApprovalComplete} from "@/utils/helper";

export default {
  components: {
    HrdTraineeCourseComplete,
    HrdTraineeViewCourse,
    EditCertificate,
  },
  props: {
    traineeStatus: Object,
    traineStatusIds: Object,
    trainee: Object,
    detailDialog: Boolean,
  },
  data() {
    return {
      values: [],
      traineeUpdateCourseDetail: {},
      courseCompletionDialog: false,
      viewCourseDialog: false,
      title: "",
      imageSrc: "",
      editCourseDialog: false,
      activeTab: 2,
    };
  },
  watch: {
    detailDialog(isOpen) {
      if (isOpen) {
        this.activeTab = 2;
      }
    },
  },
  methods: {
    resolveCourseStatus(course) {
      if (!course || course.traineeStatusId == null) {
        return "null";
      }
      if (course.traineeStatusId == this.traineStatusIds.passId) {
        return isCertificateApprovalComplete(course) ? "pass" : "pending";
      }
      return "fail";
    },
    gotToCourseCompletion(traineUpdateCouse) {
      this.courseCompletionDialog = true;
      this.traineeUpdateCourseDetail = traineUpdateCouse;
      this.title = "Course Completion Detail";
    },
    viewCourseDetail(traineUpdateCouse) {
      this.viewCourseDialog = true;
      this.traineeUpdateCourseDetail = traineUpdateCouse;
      this.title = "Course Detail";
    },
    editCourseDetail(traineUpdateCouse) {
      this.editCourseDialog = true;
      this.traineeUpdateCourseDetail = traineUpdateCouse;
      this.title = "Edit Course Detail";
    },
    async refreshTrainee(params) {
      this.courseCompletionDialog = false;

      if (params && params.traineeUpdateId) {
        let traineeCourse = await TraineeService.traineeCourseByUpdateId(
            params.traineeUpdateId
        );

        if (
            traineeCourse.data &&
            traineeCourse.data.data &&
            traineeCourse.data.data.trainee_cat2_course
        ) {
          this.values.trainee_cat2_course =
              traineeCourse.data.data.trainee_cat2_course;
          this.values.trainee_cat2_course.courseStatus = this.resolveCourseStatus(this.values.trainee_cat2_course);
        } else {
          this.values.trainee_course = traineeCourse.data.data.trainee_course;

          this.values.trainee_course.courseStatus = this.resolveCourseStatus(this.values.trainee_course);
        }
      }
    },
    async generateCerteficate(traineUpdateCouse, options = {}) {
      const {open = true, sendEmail = false} = options || {};
      if (this.resolveCourseStatus(traineUpdateCouse) !== "pass") {
        this.$toast.warning("Certificate must be passed and approved before it can be generated.");
        return;
      }
      const url =
          settings.FRONT_URL + "traineeInformation/" + this.trainee.id;
      const params = {
        url: url,
      };

      if (sendEmail) {
        const email = this.resolveTraineeEmail();
        if (!email) {
          this.$toast.error("Trainee email is required to deliver the certificate.");
          return;
        }
      }

      const res = await TraineeService.generateQrCode(params);

      if (res.status === 200 || res.status === 201) {
        this.imageSrc = res.data;
        switch (res.data.status) {
          case 200 || 201:
            generateCertificate1(
                traineUpdateCouse,
                this.values,
                this.imageSrc.data,
                {open, sendEmail}
            );
            // this.$router.go();
            //   this.$toast.success(res.data.message);
            //   this.fetchTraineeList();
            break;
          case 500:
            this.$toast.error(res.data.message);
            break;
        }
        this.historyLoading = false;
      } else {
        this.historyLoading = false;
        this.$toast.error(
            "Unable to generate trainee certificate, please try again"
        );
      }
    },
    sendCertificateEmail(traineUpdateCouse) {
      return this.generateCerteficate(traineUpdateCouse, {open: false, sendEmail: true});
    },
    resolveTraineeEmail() {
      return resolveCertificateEmail(this.values);
    },
    generateNoneCourseCertificate(programData) {
      generateCertificate2(programData, this.values);
    },
  },
  created() {
    if (this.trainee != null) {
      this.values = this.trainee;
      if (this.values.trainee_course) {
        this.values.trainee_course.courseStatus = this.resolveCourseStatus(this.values.trainee_course);
      } else {
        this.values.trainee_cat2_course.courseStatus = this.resolveCourseStatus(this.values.trainee_cat2_course);
      }
    }
  },
};
</script>
